import React from "react"
import Helmet from 'react-helmet';
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import PostLink from "../components/post-link"

const AppsPage = ({
  data: {
    site,
    allMarkdownRemark: { edges },
  },
}) => {

  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
    .map(edge => <PostLink key={edge.node.id} post={edge.node} />)

  return (
    <Layout>
      <Helmet>
        <title>{site.siteMetadata.title} Apps</title>
        <meta name="description" content={site.siteMetadata.description} />
      </Helmet>
        <div className="headline">Notion Apps</div>
        <div className="primary-content">Apps to power up your Notion.</div>
      <h2>Apps &darr;</h2>
      <div className="grids">
        {Posts}
      </div>
    </Layout>
  )
}

export default AppsPage
export const pageQuery = graphql`
  query appsPageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
    allMarkdownRemark(filter: {frontmatter: {path: {regex: "/-app/"}}}, sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
            thumbnail
          }
        }
      }
    }
  }
`
